export type TableProps = {
  data?: VehiclesType[];
};

export type VehiclesType = {
  mat: string;
  driver: string;
  concession: string;
  // ✅ Campos adicionales
  usage?: 'CONSTRUCTION'; // Solo CONSTRUCTION (ACCIDENT no se muestra aquí)
  model?: string;
  category?: string;
  ownership?: 'INTERNAL' | 'EXTERNAL';
  plate?: string; // Alias de mat
};

type columnIDTypes = { [key: string]: { id: string; label: string } };

// @deprecated Use getVehiclesColumnNames instead
export const columnNames: columnIDTypes = {
  mat: {
    id: 'mat',
    label: 'Matrícula',
  },
  driver: {
    id: 'driver',
    label: 'Conductor',
  },
  concession: {
    id: 'concession',
    label: 'Concessió',
  },
};

// Dynamic column names with translations
export const getVehiclesColumnNames = (t: any): columnIDTypes => ({
  mat: {
    id: 'mat',
    label: t('tables:headers.plate'),
  },
  driver: {
    id: 'driver',
    label: t('tables:headers.driver'),
  },
  concession: {
    id: 'concession',
    label: t('tables:headers.concession'),
  },
});
